import React, { Component } from "react";

import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { FilePond, registerPlugin } from "react-filepond";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";

import "filepond/dist/filepond.min.css";
import "./style.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize
);

class Uploader extends Component {
  constructor(props) {
    super(props);
    this.state = { files: [], uploads: [], names: [] };
    this.sentFiles = this.sentFiles.bind(this);
    this.checkIfIsDone = this.checkIfIsDone.bind(this);
  }

  sentFiles(resp) {
    this.state.files.forEach(elem => {
      if (elem.name === resp.original) {
        let { uploads, names } = this.state;
        uploads.push(resp.url);
        names.push(resp.original);
        this.setState({ uploads, names }, () => {
          this.checkIfIsDone();
        });
      }
    });
  }

  checkIfIsDone() {
    if (this.state.uploads.length === this.state.files.length) {
      this.props.done(this.state.uploads, this.state.names);
    }
  }

  error(resp) {
    if (resp) {
      if (resp.includes("<title>")) {
        let msg = resp.split("<title>")[1].split("</title>")[0];
        if (msg === "Unauthorized") this.props.logout(this.props.user.token);
      }
    }
  }

  render() {
    return (
      // Pass FilePond properties as attributes
      <FilePond
        ref={ref => (this.pond = ref)}
        files={this.state.files}
        allowMultiple={this.props.allowMultiple}
        allowRevert
        allowFileSizeValidation
        maxFileSize={this.props.maxFileSize || "100MB"}
        labelMaxFileSizeExceeded="Arquivo muito grande"
        labelMaxFileSize="O tamanho máximo permitido é {filesize}"
        maxFiles={this.props.maxFiles}
        acceptedFileTypes={this.props.acceptedFileTypes}
        labelIdle={this.props.labelIdle}
        server={{
          url: URL.api,
          process: {
            url: `file/${this.props.type}/${this.props.user.user.id}`,
            method: "POST",
            withCredentials: false,
            headers: {
              authorization: `Bearer ${this.props.user.token}`
            },
            timeout: null,
            onload: resp => this.sentFiles(JSON.parse(resp)),
            onerror: resp => this.error(resp),
            ondata: null
          }
        }}
        onupdatefiles={fileItems => {
          this.setState({ files: fileItems.map(fileItem => fileItem.file) });
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Uploader);
